"use client"

import { GripVertical } from "lucide-react"
import * as ResizablePrimitive from "react-resizable-panels"
import PropTypes from 'prop-types'

function ResizablePanelGroup({ className = "", ...props }) {
  return (
    <ResizablePrimitive.PanelGroup
      className={`flex h-full w-full ${className}`}
      {...props} 
    />
  )
}

function ResizablePanel(props) {
  return <ResizablePrimitive.Panel {...props} />
}

function ResizableHandle({ withHandle = false, className = "", ...props }) {
  return (
    <ResizablePrimitive.PanelResizeHandle
      className={`relative flex w-px items-center justify-center bg-gray-300 hover:bg-gray-400 transition-colors ${className}`}
      {...props}
    >
      {withHandle && (
        <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-white shadow-sm">
          <GripVertical className="h-2.5 w-2.5 text-gray-600" />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  )
}

ResizablePanelGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

ResizablePanel.propTypes = {
  children: PropTypes.node
}

ResizableHandle.propTypes = {
  withHandle: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
